import { Form } from 'antd';
import ActionsStep from 'features/booking/BookingOnlineV2/ActionsStep';
import styled from 'styled-components';
import CustomerServicesStep, { customerServicesStepRef } from './CustomerServicesStep';
import CustomerStep from './CustomerStep';
import DateStaffStep, { dateStaffStepRef } from './DateStaffStep';
import HeaderStep, { titleRef } from './HeaderStep';
import ReviewStep from './ReviewStep';
import SuccessStep from './SuccessStep';
import TimeSlotStep, { timeSlotStepRef } from './TimeSlotStep';

export type STEP_NAVIGATION = 'customer' | 'date_staff' | 'time_slot' | 'time' | 'service' | 'staff' | 'review' | 'success';
type Props = {
  value?: STEP_NAVIGATION;
};
const StepNavigation = ({ value: step }: Props) => {
  const form = Form.useFormInstance();
  const onBack = () => {
    setTimeout(() => {
      titleRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    }, 10);
    if (step === 'date_staff') return form.setFieldValue('currentStep', 'customer');
    if (step === 'time_slot') return form.setFieldValue('currentStep', 'date_staff');
    if (step === 'service') return form.setFieldValue('currentStep', 'time_slot');
    if (step === 'review') return form.setFieldValue('currentStep', 'service');
  };

  if (step === 'success') return <Form.Item noStyle name={'appointment'}>
    <SuccessStep />
  </Form.Item>;

  if (step === 'customer') return <CustomerStep />;

  return <>
    <HeaderStep step={step} />
    <Container>
      {step === 'date_staff' && <DateStaffStep ref={dateStaffStepRef} />}
      {step === 'time_slot' && <TimeSlotStep ref={timeSlotStepRef} />}
      {step === 'service' && <Form.Item noStyle name={'customers'}><CustomerServicesStep ref={customerServicesStepRef} /></Form.Item>}
      {step === 'review' && <ReviewStep />}
    </Container>
    <ActionsStep
      onNext={step !== 'review' ? () => form.submit() : undefined}
      onBook={step === 'review' ? () => form.submit() : undefined}
      onDeposit={step === 'review' ? () => form.submit() : undefined}
      onBack={onBack} />
  </>;
};

export default StepNavigation;
const Container = styled.div`
min-height: 90vh;
border-radius: 24px 24px 0 0;
background: #FFF;
padding: 0 16px;
padding-top: 16px;
padding-bottom: 24px;
box-shadow: 0 -4px 8px -4px rgba(0, 0, 0, 0.15);
`;
